import React from "react";
import { Star, Quote } from "lucide-react";
import { testimonials } from "../mock";

const Testimonials = () => {
  return (
    <section className="relative py-20 lg:py-28 bg-cream">
      <div className="max-w-7xl mx-auto px-6 lg:px-10">
        <div className="max-w-2xl">
          <div className="flex items-center gap-2 text-xs uppercase tracking-[0.25em] text-[#daae9c]">
            <span className="w-6 h-px bg-sterling-dark" />
            Words From Our Clients
          </div>
          <h2 className="font-serif-display text-4xl md:text-5xl lg:text-6xl text-ink mt-4 leading-[1.05] text-balance">
            A quiet luxury,{" "}
            <span className="italic text-[#daae9c]">felt every visit.</span>
          </h2>
        </div>

        <div className="mt-12 grid md:grid-cols-2 lg:grid-cols-4 gap-5">
          {testimonials.map((t, i) => (
            <div
              key={i}
              className="group relative p-7 bg-white rounded-2xl border border-[#ead8c9] hover:border-sterling-dark transition-all hover:-translate-y-1 hover:shadow-[0_20px_40px_-20px_rgba(138,93,72,0.25)]"
            >
              <Quote
                size={28}
                className="text-sterling absolute top-6 right-6 opacity-50"
              />
              <div className="flex items-center gap-1">
                {Array.from({ length: t.rating }).map((_, k) => (
                  <Star
                    key={k}
                    size={14}
                    fill="#daae9c"
                    className="text-sterling"
                  />
                ))}
              </div>
              <p className="mt-4 text-ink/80 leading-relaxed text-sm">
                “{t.text}”
              </p>
              <div className="mt-6 pt-4 border-t border-[#ead8c9]">
                <div className="font-serif-display text-lg text-ink">
                  {t.name}
                </div>
                <div className="text-xs text-[#daae9c] uppercase tracking-wider mt-0.5">
                  {t.location}
                </div>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default Testimonials;
